import { createTheme, alpha } from '@mui/material';

const createAppTheme = (mode: 'light' | 'dark') => {
  const isLight = mode === 'light';
  
  return createTheme({
    palette: {
      mode,
      primary: {
        main: '#1e3a5f',
        light: '#2d4e7d',
        dark: '#132844',
      },
      secondary: {
        main: '#9b2c2c',
        light: '#bc3f3f',
        dark: '#7a1f1f',
      },
      background: {
        default: isLight ? '#f8f9fa' : '#1a1a1a',
        paper: isLight ? '#ffffff' : '#262626',
      },
      text: {
        primary: isLight ? '#2d3748' : '#e2e8f0',
        secondary: isLight ? '#4a5568' : '#a0aec0',
      },
    },
    typography: {
      fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
      h4: {
        fontWeight: 700,
        letterSpacing: '-0.02em',
        color: isLight ? '#1e3a5f' : '#e2e8f0',
      },
      h6: {
        fontWeight: 600,
        letterSpacing: '-0.01em',
      },
    },
    shape: {
      borderRadius: 12,
    },
    components: {
      MuiAppBar: {
        styleOverrides: {
          root: {
            background: isLight 
              ? 'linear-gradient(135deg, #1e3a5f, #2d4e7d)'
              : 'linear-gradient(135deg, #132844, #1e3a5f)',
            backdropFilter: 'blur(10px)',
            borderBottom: `1px solid ${isLight ? alpha('#1e3a5f', 0.1) : alpha('#132844', 0.2)}`,
          },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          paper: {
            borderRight: 'none',
            background: isLight 
              ? '#ffffff'
              : '#262626',
            boxShadow: isLight 
              ? '4px 0 24px rgba(0, 0, 0, 0.03)'
              : '4px 0 24px rgba(0, 0, 0, 0.2)',
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
            boxShadow: isLight 
              ? '0 4px 24px rgba(0, 0, 0, 0.03)'
              : '0 4px 24px rgba(0, 0, 0, 0.2)',
            border: `1px solid ${isLight ? alpha('#1e3a5f', 0.1) : alpha('#132844', 0.2)}`,
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            fontWeight: 600,
            borderRadius: 8,
          },
          contained: {
            background: isLight 
              ? '#1e3a5f'
              : '#2d4e7d',
            boxShadow: 'none',
            '&:hover': {
              background: isLight ? '#2d4e7d' : '#1e3a5f',
            },
          },
        },
      },
      MuiListItem: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            margin: '4px 8px',
            width: 'auto',
            '&:hover': {
              background: isLight 
                ? alpha('#1e3a5f', 0.08)
                : alpha('#132844', 0.15),
            },
          },
        },
      },
      MuiTableHead: {
        styleOverrides: {
          root: {
            '& .MuiTableCell-root': {
              fontWeight: 600,
              color: isLight ? '#2d3748' : '#e2e8f0',
              background: isLight 
                ? alpha('#1e3a5f', 0.03)
                : alpha('#132844', 0.1),
              borderBottom: `2px solid ${isLight ? alpha('#1e3a5f', 0.1) : alpha('#132844', 0.2)}`,
            },
          },
        },
      },
      MuiTableRow: {
        styleOverrides: {
          root: {
            '&:hover': {
              background: isLight 
                ? alpha('#1e3a5f', 0.03)
                : alpha('#132844', 0.1),
            },
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            borderRadius: 6,
            fontWeight: 500,
          },
        },
      },
    },
  });
};

export { createAppTheme };